import { App } from "@/app";
// import State from "@lib/hey";
import { Core } from "@unseenco/taxi";
import { Transition } from "@lib/page-transitions";
import { Scroll } from "@lib/scroll";
import { splitTextSetup } from "@/utils/split-text";
import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

const PAGES_CONFIG = {
  links:
    "a:not([target='_blank']):not([target='_parent']):not([target='_top']):not([href^=\\#]):not([data-taxi-ignore])",
  removeOldContent: true,
  allowInterruption: false,
  bypassCache: false,
};

export interface TransitionParams {
  from?: Element | HTMLElement;
  to?: Element | HTMLElement;
  trigger: HTMLAnchorElement;
  wrapper: HTMLElement | any;
  destination?: string;
}

export class _Pages extends Core {
  constructor() {
    console.log("🚌 Taxi.js initializing...");

    super({
      ...PAGES_CONFIG,
      transitions: {
        default: Transition,
      },
    });

    console.log("✅ Taxi.js initialized");
    console.log("🔍 Taxi will intercept links matching:", PAGES_CONFIG.links);

    this.init();
  }

  async init() {
    await splitTextSetup();
    createCycles();
    runPageIn();
    runMount();
  }

  async transitionOut({ from, trigger }: TransitionParams) {
    await Promise.allSettled([
      await runPageOut(from),
      // ...
    ]);

    runDestroy(from);
    Scroll.toTop();
  }

  async transitionIn({ to, trigger }: TransitionParams) {
    await splitTextSetup(to); // Setup SplitText in new page container
    createCycles("module", to); // Only initialize components in new page container

    // State.PAGE = to;

    await Promise.allSettled([
      await runPageIn(),
      // ...
    ]);

    runMount();
  }
}

export const Pages = new _Pages();
